// extracted by mini-css-extract-plugin
export var cols = "style-mod--cols--4d7e9";
export var contentTc = "style-mod--content-tc--44431";
export var tcContent = "style-mod--tc-content--cace0";
export var tcTitle = "style-mod--tc-title--dfddf";
export var textColumns = "style-mod--text-columns--da7a7";